import styled from "styled-components";

export const EmployeeRoot = styled.div`
    display:block;
    position:relative;
    min-height:100vh;
    width:100%;
    background-color:#F6F6F6;
`;
